import template from './mx-shell-nav-item.html';

mxShellNavItemDirective.$inject = ['mx.components.Recursion'];
export function mxShellNavItemDirective(recursion) {
	return {
		bindToController: { item: '<mxShellNavItem', favouriteMode: '<favouriteMode' },
		compile(element) {
			return recursion.compile(element);
		},
		controller: MxShellNavItemCtrl,
		controllerAs: 'vm',
		restrict: 'A',
		scope: {},
		template: template,
	};
}

/**
 * @ngdoc directive
 * @name mx.shell:mxShellNavItem
 * @module mx.shell
 * @restrict 'A'
 * @scope {}
 * @requires <a href="https://material.angularjs.org/latest/api/service/$mdSidenav" target="_blank">$mdSidenav</a>
 * @requires {@ref mx.components.Recursion mx.components.Recursion}
 * @requires {@ref mx.shell.EventService mx.shell.EventService}
 * @requires {@ref mx.shell.RoutingService mx.shell.RoutingService}
 * @requires {@ref mx.shell.NavigationManager mx.shell.NavigationManager}
 * @requires {@ref mx.internationalization mx.internationalization}
 * @requires $mdSidenav
 * @requires mx.components.DragNDropUtils
 * @description
 * Presentation of a sidebar navigation item
 *
 * @param {mx.shell.NavigationItem} item= - {@ref mx.shell.NavigationItem Navigation Item model}
 * @usage <li mx-shell-nav-item="item"></li>
 */

MxShellNavItemCtrl.$inject = [
	'$scope',
	'$mdSidenav',
	'mx.app.DeviceService',
	'$timeout',
	'$element',
	'$attrs',
	'$window',
	'mx.shell.NavigationManager',
	'mx.shell.NavigationService',
	'mx.shell.EventService',
	'mx.internationalization',
	'mx.components.DragNDropUtils',
	'mx.shell.NavigationItemConfigurationActionsService',
	'mx.shell.RoutingService',
];

function MxShellNavItemCtrl(
	$scope,
	$mdSidenav,
	deviceService,
	$timeout,
	$element,
	$attrs,
	$window,
	navigationManager,
	navigationService,
	eventService,
	i18n,
	dragDrop,
	navigationItemConfigurationActionsService,
	routingService
) {
	const vm = this;

	vm.NavigationManager = navigationManager;

	vm.navigationConfigurationModeOn = navigationService.configurationModeOn;

	vm.favouriteMode = $attrs.favouriteMode;

	eventService.subscribeTo(mx.shell.EventCodes.NavToggled, onNavBarToggled, $scope);
	eventService.subscribeTo(
		mx.shell.EventCodes.NavigationConfigurationModeChanged,
		(e, value) => {
			vm.navigationConfigurationModeOn = value;
			vm.item.beingConfigured = false;
			if (!value) {
				vm.item.configurationModeOn = false;
			}
		},
		$scope
	);
	eventService.subscribeTo(
		mx.shell.EventCodes.NavigationItemEnteredConfigurationMode,
		(e, item) => {
			if (item !== vm.item && vm.item.configurationModeOn && vm.item.configurable) {
				_switchConfigurationMode();
			}
		},
		$scope
	);

	const _tryShowMoreItemsDebounced = $.debounce(100, _tryShowMoreItems);

	vm.$onInit = () => {
		if (vm.item) {
			// set level
			if (vm.item.level === undefined) {
				vm.item.level = vm.item.parent && vm.item.parent.level !== undefined ? vm.item.parent.level + 1 : 0;
			}

			// TODO: `parameters`, `filterType`, `'structure'` it's just Agent specific and should be removed from mxShell.
			if (vm.item.parameters) {
				vm.item.isRootItemChildrenDynamicLoader = vm.item.parameters.filterType === 'structure' && !(vm.item.parent && vm.item.parent.childrenDynamicLoader);
			}

			vm.handleItemClick = _handleItemClick;

			vm.route = vm.item.route;

			vm.htmlClass = `mx-nav-item--${(vm.item ? vm.item.name : '').replace(/\./g, '--')}`;
			// TODO: why do we need `vm.itemTitleClass` if we have `vm.htmlClass` ???
			// If it's need to use `title` for some reason - why don't just search elements by it's selector and content?
			vm.itemTitleClass = `mx-nav-item--auto-${vm.item.name.toLowerCase().replace('&', '-').split(' ').join('')}`;

			vm.hasChildrenCommonFilter = function () {
				return vm.favouriteMode
					? vm.item.children.filter(vm.favoriteFilter).length > 0
					: typeof vm.item.childrenDynamicLoader === 'function' || (vm.item.children && vm.item.children.length > 0);
			};

			// Init context menu
			if (vm.item.configurable) {
				$element.bind('contextmenu', (event) => {
					event.preventDefault();
					event.stopPropagation();
					$scope.$evalAsync(() => {
						navigationManager.contextMenuData = {
							event,
							itemContextMenuExpanded: true,
							itemContextMenu: [
								{
									icon: 'settings',
									label: i18n.get('shell.mx-shell-nav.customizeNav'),
									onItemClick(event) {
										if (vm.item.isRootItemChildrenDynamicLoader) {
											event.preventDefault();
											event.stopPropagation();
											navigationService.loadChildren(vm.item);
										}
										vm.item.configurationModeOn = true;
									},
								},
							],
						};
					});
				});
			}

			vm.configurationActions = vm.item.__fromFilter
				? navigationItemConfigurationActionsService.getFilterActions(vm.item)
				: navigationItemConfigurationActionsService.getAddingChildItemAction(vm.item);
		}
	};

	vm.$postLink = () => {
		vm.itemBtnEl = $element.find('.mx-shell-nav-item--btn');
		if (vm.item && (vm.item.childrenDynamicLoader || vm.item.children.length)) {
			vm.itemBtnEl.attr('aria-haspopup', 'true');
			vm.itemBtnEl.attr('aria-expanded', 'false');
		}
	};

	vm.handleArrowClick = _handleArrowClick;
	vm.switchConfigurationMode = _switchConfigurationMode;

	vm.deviceService = deviceService;
	vm.onDrop = onDrop;
	vm.dragModeOn = dragModeOn;
	vm._formatAsHtmlClass = _formatAsHtmlClass;

	vm.favoriteFilter = ({ showInFavorite }) => {
		if (vm.favouriteMode) {
			return showInFavorite;
		}
		return true;
	};

	$scope.$watchCollection('vm.item.children', (children) => {
		if (Array.isArray(children)) {
			_tryInitShowMore();
		}
	});

	$scope.$watch('vm.item.selected', () => {
		_tryInitShowMore();
		if (vm.item && vm.item.selected !== undefined && (vm.item.childrenDynamicLoader || vm.item.children.length)) {
			vm.itemBtnEl.attr('aria-expanded', !!vm.item.selected);
		}
	});

	// Allows highlight just items from the same level (not all items per all structure)
	$element.on('dragstart', '> .mx-shell-nav-item--btn', _handleDragStart).on('dragend', '> .mx-shell-nav-item--btn', _handleDragEnd);

	return vm;

	function _formatAsHtmlClass(htmlClass) {
		return (htmlClass || 'undefined').split(' ').join('_');
	}

	function _handleDragStart() {
		if ($('.mx-dynamic-nav-styles').length === 0) {
			$(
				`<style class="mx-dynamic-nav-styles">.mx-shell-nav-item--btn.mx-shell-nav-item--level-${vm.item.level}.mx-drag-hover {border-color: ${mx.currentThemeColorsObj['active-color']};}</style>`
			).appendTo('head');
		}
	}

	function _handleDragEnd() {
		$('.mx-dynamic-nav-styles').remove();
	}

	function dragModeOn() {
		return vm.item.draggable && ((vm.item.level === 0 && vm.navigationConfigurationModeOn) || (vm.item.level > 0 && vm.item.configurationModeOn));
	}

	function _switchConfigurationMode() {
		vm.item.configurationModeOn = !vm.item.configurationModeOn;
		if (vm.item.configurationModeOn) {
			eventService.dispatchEvent(mx.shell.EventCodes.NavigationItemEnteredConfigurationMode, vm.item);
		}
	}

	async function onDrop($event) {
		const receiverItem = vm.item;
		const movedItemName = dragDrop.getDropData($event).movedItemName;

		await navigationService.changeNavigationOrdering(movedItemName, receiverItem);
	}

	function _handleArrowClick($event, item) {
		$event.preventDefault();
		$event.stopPropagation();

		if (item.selected) {
			$timeout(() => {
				item.selected = false;
			});
		} else {
			navigationService.loadChildren(item);
			item.selected = true;
		}
	}

	function onNavBarToggled() {
		if (vm.item.selected) {
			vm.item.selected = false;
		}
	}

	function _handleItemClick($event, item) {
		$event.preventDefault();
		$event.stopPropagation();
		let handleItemClickPromise = routingService.isCurrent(item.route, item.parameters) ? routingService.reload() : navigationService.setCurrentNavigationItem(item);
		eventService.dispatchEvent(mx.shell.EventCodes.TrackTelemetry, { eventName: `Navigation clicked`, sender: item.id, senderTitle: item.technicalName });

		handleItemClickPromise
			.then(() => {
				eventService.dispatchEvent(mx.shell.EventCodes.NavigationItemClicked, item);

				vm.item.beingConfigured = vm.item.configurationModeOn && item === vm.item;

				if (deviceService.screenMobile() && item.route) {
					$mdSidenav('mx-shell-left-sidebar').close();
				}
			})
			.catch(mx.logCatch);
	}

	function _tryInitShowMore() {
		vm.__limitTo = 50;
		if (vm.__limitTo < vm.item.children?.length && vm.item.selected) {
			_tryShowMoreItemsDebounced();
			$window.addEventListener('scroll', _tryShowMoreItemsDebounced, true);
		}
	}

	function _tryShowMoreItems() {
		const showMoreBtn = $element.find('.mx-shell-nav-item--show-more');
		if (showMoreBtn.length > 0 && showMoreBtn.offset().top < $($window).height()) {
			showMoreBtn.click();
		} else if (showMoreBtn.length === 0) {
			$window.removeEventListener('scroll', _tryShowMoreItemsDebounced, true);
		}
	}
}
